import theme from '@totallymoney/ui/theme'
import React from 'react'

import {
    StyledLoanTableContentBase,
    StyledLoansTableMarketingOfferContentBase,
} from './LoansTableContentBase.styled'

interface ContentBaseProps {
    hasMarketingOffer?: boolean
    children: React.ReactNode
}

const LoansTableContentBase = ({
    hasMarketingOffer,
    children,
}: ContentBaseProps) => {
    if (hasMarketingOffer) {
        return (
            <StyledLoansTableMarketingOfferContentBase
                display="grid"
                gridTemplateColumns={[
                    '1fr',
                    'repeat(4, 1fr)',
                    'repeat(6, 1fr)',
                ]}
                gridGap={[
                    theme.space10,
                    `${theme.space60} ${theme.space20}`,
                    theme.space10,
                ]}
            >
                {children}
            </StyledLoansTableMarketingOfferContentBase>
        )
    }

    return (
        <StyledLoanTableContentBase
            display="flex"
            flexDirection={['column', 'row']}
            maxHeight={['unset', '150px']}
        >
            {children}
        </StyledLoanTableContentBase>
    )
}

export default LoansTableContentBase
